"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
function create(tokens) {
    const length = tokens.length + 1;
    const resumable_chart = new Array();
    for (let i = 0; i < length; i++) {
        resumable_chart.push(new Map());
    }
    return resumable_chart;
}
exports.create = create;
//# sourceMappingURL=resumable-chart-create.js.map